"use strict";
import { __exports as r } from "./index.es487.js";
var n;
function i() {
  return n ? r : (n = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "escapeStringRegexp", {
      enumerable: !0,
      get: function() {
        return c;
      }
    });
    const p = /[|\\{}()[\]^$+*?.-]/, u = /[|\\{}()[\]^$+*?.-]/g;
    function c(e) {
      return p.test(e) ? e.replace(u, "\\$&") : e;
    }
  })(r), r);
}
export {
  i as __require
};
//# sourceMappingURL=index.es453.js.map
